import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import { FormValidatorSlots } from '../_app/cuchillo/forms/FormValidatorSlots';
import Default from './Default';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { WinMessage } from '../_app/cuchillo/windows/Message';

export default class Building extends Default {
  formValidator;
  mssg_ok;
  mssg_ko;

  _calls = {
    cb: success => this.callback(success)
  }

  constructor() {
    super();

    const form = GetBy.class('__form', this.container)[0];

    if (form) {
      this.mssg_ok = form.dataset.mssgOk;
      this.mssg_ko = form.dataset.mssgKo;

      this.formValidator = new FormValidatorSlots(form, this._calls.cb);
    }
  }

  //SHOW
  beforeShow() {
    super.beforeShow();

    const backButton = GetBy.selector('.back [data-back]')[0];
    const lastListingUrl = sessionStorage.getItem('lastListingUrl');
    if (backButton && lastListingUrl) {
      backButton.setAttribute('data-href', lastListingUrl);
    }

    if (!this.formValidator) return;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    fetch(`/api/get-project?projId=${this.container.dataset.id}&postType=${this.container.dataset.postType}`)
      .then(response => response.json())
      .then(project => {
        if (project.error) {
          console.error('Error fetching project:', project.error);
          return;
        }

        let anySlotsLeft = false;

        project.acf.events.map(event => {
          const radio = GetBy.id('custom-radio-event-' + Functions.slugify(event.name))
          const input = GetBy.selector('input', radio)[0];
          const number = GetBy.class('number', radio)[0];

          let assistants = 0;
          if (event.assistants) assistants = event.assistants.length;
          const slots = parseInt(event.slots);
          const left = slots - assistants;

          if (left === 0) {
            input.setAttribute('disabled', 'disabled');
          } else {
            input.removeAttribute('disabled');
            anySlotsLeft = true;
          }

          input.dataset.slots = left;
          number.innerHTML = left;
        });

        const submitButton = GetBy.id('send');
        if (submitButton && anySlotsLeft) submitButton.removeAttribute('disabled');
      })
      .catch(error => {
        console.error('Error:', error);
      });

    if (urlParams.get('success') !== null) {
      if (urlParams.get('success') === 'true') {
        WinMessage.success(this.mssg_ok);
        // Comentat: dispara massa deploys durant les proves i no deixa
        // testejar la plataforma. Les places es mantenen actualitzades via
        // JS (beforeShow() -> /api/get-project) sense necessitat de rebuild.
        // this.triggerDeploy();
      } else {
        WinMessage.success(this.mssg_ko);
      }

      urlParams.delete('success');
    }
  }

  callback(success = true) {
    let url = new URL(window.location.href);
    let params = url.searchParams;

    params.set('success', success ? 'true' : 'false');
    window.location.href = url.toString();
  }

  triggerDeploy() {
    fetch('/.netlify/functions/trigger-deploy', { method: 'POST' })
      .then(response => response.json())
      .then(data => {
        // window.history.replaceState({}, document.title, '/');
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  afterHide() {
    if (this.formValidator) this.formValidator.dispose();
    super.afterHide();
  }
}

ControllerPage._addPage('building', Building);
